class BluePanel extends Panel {
    constructor(identifier: string, contents: string, container: JQuery, controller: Controller, widgetFactory: WidgetFactory, defaultAction: Action, mode: string) {
        super(identifier, contents, container, controller, mode, Action.NONE);

        this.controller = controller;

    }

    initHTML(container, label) {
        var newHTML = '<div class="panel" id="' + this.identifier + '_blue">' + label + '</div>';

        this.container = $(newHTML);

        container.replaceWith(this.container);
    }

    setEnabled(enabled: boolean) {
        this.container.toggleClass("disabled", !enabled);
    }
    
    isEnabled(): boolean {
        return !this.container.hasClass("disabled");
    }
    
    previewEnabled(enabled: boolean) {
        if (enabled && this.container.hasClass("disabled")) {
            this.container.addClass("feedforward_enabled");
        } else if (!enabled && !this.container.hasClass("disabled")) {
            this.container.addClass("feedforward_disabled");
        }
    }
    
    setVisible(visible: boolean) {
        this.container.toggleClass("hidden", !visible);
    }
    
    previewVisible(visible: boolean) {
        console.log("TODO: implement previewVisible() in all buttons");
    }
    
    isVisible(): boolean {
       return !this.container.hasClass("hidden");
    }
    
    setSelected(selected: boolean) {
        this.container.toggleClass("selected", selected);
    }
    
    previewSelected(selected: boolean) {
        if(this.container.hasClass("selected") && !selected) {
            this.container.addClass("feedforward_deselected");
        } else if(!(this.container.hasClass("selected")) && selected) {
            this.container.addClass("feedforward_selected");
        }
    }
    
    isSelected(): boolean {
        return this.container.hasClass("selected");
    }
    
    removeNextStatePreview() {
        this.container.removeClass("feedforward_enabled feedforward_disabled");
        this.container.removeClass("feedforward_selected feedforward_deselected");
    }

    removePreviewEnabled() {
        // TODO
    }
}